// LIBRERIE/IMPORTS
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBath, faBorderAll, faRulerCombined } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import he from "he";

// COMPONENTI
import NotFoundProperty from '../Error/NotFoundProperty';

// CONFIGURAZIONI & TIPI
import { Property } from '../../types/property';
import appConfig from '../../config/appConfig';


interface ImmobiliGridProps {
    properties: Property[];
    loading: boolean;
    error: any;
    basePath: string;
    labelSold: boolean;
}

const ImmobiliGrid: React.FC<ImmobiliGridProps> = ({ properties, loading, error, basePath, labelSold }) => {
    const { t, i18n } = useTranslation();

    if (!loading && !error && properties.length === 0) {
        return <NotFoundProperty />;
    }

    const getPropertyName = (property: Property) => {
        return `${property.tipologyDetails.name}${t('property.inAddress', ' a ')}${property.addressDetails.quartiereName || property.addressDetails.frazioneName || property.addressDetails.comuneName}`;
    };

    const langPrefix = appConfig.integrations.multilang ? `/${i18n.language}` : '';

    const negotiableText = t('common.negotiable');

    return (
        <>
            {properties.map((property: Property) => {
                const propertyName = getPropertyName(property);
                const propertyUrl = `${langPrefix}/${basePath}/${property.id}`;
                const vani = property.premises ?? 0;
                return (

                    <div className="col-md-6 col-lg-4" key={property.id}>

                        <Link to={propertyUrl} className="property-item">

                            <div className="property-image bg-overlay-gradient-04">

                                <img
                                    className="img-fluid"
                                    src={property.mainImage}
                                    alt={t('property.card.imageAltBase', 'Immagine proprietà') + ` ${propertyName}`}
                                />

                                {labelSold ? (
                                    <div className="property-lable">
                                        <span className="badge badge-md badge-successi">
                                            VENDUTO DA NOI
                                        </span>
                                    </div>
                                ) : (
                                    <div className="property-lable">
                                        {property.contractDetails?.name && (
                                            <span className="badge badge-md badge-primary">
                                                {t(`property.contractTypes.${property.contractDetails.name}`, property.contractDetails.name)}
                                            </span>
                                        )}
                                        {property.auctionDetails?.auction && (
                                            <span className="badge badge-md badge-primary ml-2">
                                                {t('property.auction')}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="property-lable-bottom-left"></div>

                                {property.exclusive && (
                                    <div className="property-esclusiva-box">
                                        <span className="property-esclusiva">{t('property.exclusive', 'Esclusiva')}</span>
                                    </div>
                                )}

                                <div className="property-price">
                                    {property.priceDetails.reservedNegotiation
                                        ? t('property.priceReserved')
                                        : property.auctionDetails?.auction
                                            ? `da € ${new Intl.NumberFormat("it-IT").format(property.priceDetails.price)}`
                                            : `€ ${new Intl.NumberFormat("it-IT").format(property.priceDetails.price)}${property.priceDetails.negotiable ? ` ${negotiableText}` : ""}`
                                    }
                                </div>
                            </div>
                            <div className="property-details">
                                <div className="property-details-inner">

                                    <h5 className="property-title">
                                        {property.tipologyDetails.name}
                                    </h5>

                                    <p className="property-address mb-2">
                                        {property.addressDetails.frazioneName || property.addressDetails.quartiereName ?
                                            `${property.addressDetails.frazioneName || property.addressDetails.quartiereName}, ${property.addressDetails.comuneName} (${property.addressDetails.provinciaSigla ?? ""})`
                                            : property.addressDetails.comuneName ?
                                                `${property.addressDetails.comuneName} (${property.addressDetails.provinciaSigla ?? ""})`
                                                : property.addressDetails.provinciaName ?? ''
                                        }
                                    </p>

                                    <ul className="property-info list-unstyled d-flex">
                                        <li title={`${vani} ${t('common.room', { count: vani })}`}>
                                            <i>
                                                <FontAwesomeIcon icon={faBorderAll} />
                                            </i>
                                            <span>{vani}</span>
                                            <span className="m-0">{t('common.premises')}</span>
                                        </li>
                                        {property.bathrooms != null && property.bathrooms !== 0 ? (
                                            <li>
                                                <i>
                                                    <FontAwesomeIcon icon={faBath} />
                                                </i>
                                                <span>{property.bathrooms}</span> {property.bathrooms === 1 ? t('common.bathroom', 'Bagno') : t('common.bathrooms', 'Bagni')}
                                            </li>
                                        ) : <li aria-hidden="true" style={{ display: 'none' }} />}
                                        {property.sqmt && property.sqmt !== 0 ? (
                                            <li>
                                                <i>
                                                    <FontAwesomeIcon icon={faRulerCombined} />
                                                </i>
                                                <span>{property.sqmt} m²</span>
                                            </li>
                                        ) : <li aria-hidden="true" style={{ display: 'none' }} />}
                                    </ul>
                                    <p className="property-desc" dangerouslySetInnerHTML={{ __html: he.decode(property.descriptions?.[0].text.substring(0, 150) + "...") }} />
                                </div>
                                <ul className="property-listing-actions list-unstyled mb-0 text-right">
                                    <li className="property-rif">
                                        {t('property.reference', 'Rif.')} {property.ref}
                                    </li>
                                </ul>
                            </div>
                        </Link>
                        
                    </div>
                );
            })}
        </>
    );
};

export default ImmobiliGrid;